import { memo } from 'react'
import cn from 'classnames'

import { Card } from '~/shared/ui/Card'
import { Placeholder } from '~/shared/ui/Placeholder'

import type { EmptyStateProps } from './types'

import styles from './EmptyState.module.scss'

/**
 * Пустое состояние внутри карточки (спека 01, компонент 08) — тонкая обёртка над
 * `Placeholder` (основатель, п.20): сам вид иллюстрации/заголовка/описания живёт там,
 * `EmptyState` лишь добавляет карточку-подложку, привычную вызывающим экранам.
 *
 * Это ЕДИНСТВЕННОЕ пустое состояние продукта (правка основателя): раньше «нет уведомлений»
 * и «пустой архив сбываемости» были собраны по-разному и выглядели как два разных экрана.
 * Отличаются они теперь только позой Луни (`name`) и текстом, который приходит пропсами
 * из `modules/lunya/copy`.
 *
 * Для шторок и полноэкранных состояний без карточки используйте `Placeholder` напрямую
 * (так делает поиск города: карточка внутри карточки-шторки выглядела бы вложенной).
 */
export const EmptyState = memo(function EmptyState(props: EmptyStateProps) {
  const { name = 'EMPTY', height = 'AUTO', title, description, action } = props

  return (
    <div className={cn(styles.root, height === 'FILL' && styles.height_FILL)}>
      <Card padding='L'>
        <Placeholder name={name} title={title} description={description} action={action} />
      </Card>
    </div>
  )
})
